import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { NotFoundPageComponent } from "@gloria-public/error/views/not-found-page/not-found-page.component";
import { HomePageComponent } from "@gloria-public/home/views/home-page/home-page.component";
import { LandingPageComponent } from "@gloria-public/landing/views/landing-page/landing-page.component";
import { LoginPageComponent } from "@gloria-public/login/views/login-page/login-page.component";
import { ResetPasswordPageComponent } from "@gloria-public/login/views/reset-password-page/reset-password-page.component";
import { CheckoutPageComponent } from "@gloria-public/order/views/checkout-page/checkout-page.component";
import { OrderHistoryPageComponent } from "@gloria-public/order/views/order-history-page/order-history-page.component";
import { PaymentPageComponent } from "@gloria-public/order/views/payment-page/payment-page.component";
import { PaymentResultComponent } from "@gloria-public/order/views/payment-result/payment-result.component";
import { ShoppingCartPageComponent } from "@gloria-public/order/views/shopping-cart-page/shopping-cart-page.component";
import { QuestionnaireCompletedPageComponent } from "@gloria-public/questionnaire/views/questionnaire-completed-page/questionnaire-completed-page.component";
import { QuestionnairePageComponent } from "@gloria-public/questionnaire/views/questionnaire-page/questionnaire-page.component";
import { LinkPageComponent } from "@gloria-public/register/views/link-page/link-page.component";
import { RegistrationPageComponent } from "@gloria-public/register/views/registration-page/registration-page.component";
import { RiskDetailsPageComponent } from "@gloria-public/risk/views/risk-details-page/risk-details-page.component";
import { RisksPageComponent } from "@gloria-public/risk/views/risks-page/risks-page.component";
import { AuthGuard } from "./guards/auth.guard";
import { LoginGuard } from "./guards/login.guard";

const routes: Routes = [
  {
    path: "",
    redirectTo: "landing",
    pathMatch: "full",
  },
  {
    path: "landing",
    component: LandingPageComponent,
  },
  {
    path: "login",
    component: LoginPageComponent,
    canActivate: [LoginGuard],
  },
  {
    path: "registration",
    component: RegistrationPageComponent,
  },
  {
    path: "reset-password",
    component: ResetPasswordPageComponent,
  },
  {
    path: "link",
    component: LinkPageComponent,
  },
  {
    path: "home",
    component: HomePageComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "order-history",
    component: OrderHistoryPageComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "risks",
    children: [
      { path: "", component: RisksPageComponent },
      {
        path: ":riskId",
        component: RiskDetailsPageComponent,
      },
      {
        path: ":riskId/questionnaires/:questionnaireId",
        component: QuestionnairePageComponent,
      },
      {
        path: ":riskId/questionnaires/:questionnaireId/completed",
        component: QuestionnaireCompletedPageComponent,
      },
    ],
  },
  {
    path: "cart",
    children: [
      { path: "", component: ShoppingCartPageComponent },
      { path: "checkout", component: CheckoutPageComponent, canActivate: [AuthGuard] },
    ],
  },
  {
    path: "payment",
    component: PaymentPageComponent,
  },
  {
    path: "payment/return",
    component: PaymentResultComponent,
  },
  {
    // Always have to be the last in the list
    path: "**",
    component: NotFoundPageComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: "enabled",
      anchorScrolling: "enabled",
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
